import type { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import Button from "@/components/Button/Button"

import style from "./TicketsStyle.module.css"

export default function TicketsFilter({
  filter,
  setFilter,
}: {
  filter: string
  setFilter: Dispatch<SetStateAction<string>>
}) {
  const { t } = useTranslation()
  const filterBtns = [
    { label: t("ticketsPage.filters.all"), value: "" },
    { label: t("ticketsPage.filters.pending"), value: "0" },
    { label: t("ticketsPage.filters.opened"), value: "1" },
    { label: t("ticketsPage.filters.inProgress"), value: "2" },
    { label: t("ticketsPage.filters.closed"), value: "3" },
  ]

  return (
    <div className={`d-flex align-items-center gap-3 ${style.filter_con} `}>
      {filterBtns.map((btn, index) => {
        return (
          <Button
            onClick={() => setFilter(btn.value)}
            key={index}
            className={` ${filter === btn.value && style["active"]}`}
          >
            {btn.label}
          </Button>
        )
      })}
    </div>
  )
}
